import {
  AutoComplete,
  Button,
  Drawer,
  Form,
  Input,
  Select,
  Spin,
  Switch,
} from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, getParamValue, jcTypeArray } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import { EditOutlined, CheckOutlined, CloseOutlined } from "@ant-design/icons";
import TopHeading from "./TopHeading";
import PromoCodeDetails from "./Details";
import Empty from "../common/Empty";
import AddPromo from "./AddPromo";
import { responseNotification } from "../../utils/notify";
import moment from "moment";
import { debounce } from "lodash";
const { Option } = Select;

const PromoCodeList = () => {
  const [loading, setLoading] = useState(undefined);
  const [status, setStatus] = useState();
  const [type, setType] = useState("JC_MART");
  const [limit, setLimit] = useState(16);
  const [key, setKey] = useState("");

  const [promoOptions, setPromoOptions] = useState({
    loading: false,
    list: [],
  });

  const [promoData, setPromoData] = useState({
    loading: false,
    data: null,
  });

  const [selectedPromo, setSelectedPromo] = useState(null);
  const [selectedId, setSelectedId] = useState(null);
  const [selectedPromoForEdit, setSelectedPromoForEdit] = useState(undefined);

  const [form] = Form.useForm();
  const loc = useLocation();
  const page = getParamValue(loc.search, "page");

  const reseAllFieldData = () => {
    form.resetFields();
    setStatus(undefined);
    setKey("");
    setType("JC_MART");
  };

  const getPromoCode = useCallback(async () => {
    setPromoData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
    axios
      .get(
        `${encodedUri}/admin/promo/all/V2?page=${page || 0}&limit=${
          limit || 16
        }` +
          (type ? `&type=${type}` : ``) +
          (key ? `&promo=${key}` : ``) +
          (status ? `&isActive=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setPromoData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setPromoData({ loading: false, data: [] });
        console.error("Promo: Error", err);
      });
  }, [key, limit, page, status, type]);

  const getPromoOptions = useCallback(
    async (key?: string) => {
      setPromoOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_ORDER_API}`;
      const res = await axios.get(
        `${encodedUri}/admin/promo/all/V2?page=0&limit=20` +
          (key ? `&promo=${key}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setPromoOptions({
        loading: false,
        list: res.data?.promos?.map((promo) => ({
          label: promo.promoCode,
          value: promo.promoCode,
        })),
      });
    },
    [type]
  );

  const fetchRef = useRef(null);

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (value) {
        if (field === "promo") getPromoOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [getPromoOptions]);

  useEffect(() => {
    getPromoCode();
    getPromoOptions();
  }, [getPromoCode, getPromoOptions]);

  //
  const onStatusChange = async (id, val) => {
    if (id) {
      setLoading(true);
      await fetch(`${process.env.REACT_APP_ORDER_API}/admin/promo`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          promoCodeId: id,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getPromoCode();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  //

  // useEffect(() => {
  //   if (visible) {
  //     setSelectedPromo(null);
  //     setSelectedPromoForEdit(undefined);
  //   }
  // }, [selectedPromo, selectedPromoForEdit, visible]);

  useEffect(() => {
    setSelectedPromo(null);
    setSelectedPromoForEdit(undefined);
    setSelectedId(null);
  }, []);

  const onClose = () => {
    setSelectedId(null);
    setSelectedPromo(null);
    setSelectedPromoForEdit(null);
    getPromoCode();
  };

  console.log("ID:", selectedId);

  return (
    <React.Fragment>
      <TopHeading
        total={promoData?.data?.totalElements}
        refetch={getPromoCode}
      />

      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="area" initialValue={key}>
            <AutoComplete
              onSearch={(e) => handleSearch(e, "promo")}
              onSelect={(val) => setKey(val)}
              options={promoOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                promoOptions?.loading ? <Spin size="small" /> : null
              }
              style={{ minWidth: 250 }}
            >
              <Input.Search
                size="large"
                placeholder="Search by Promo"
                onSearch={(val) => {
                  setKey(val);
                  console.log(val);
                }}
                enterButton
                loading={promoOptions.loading}
                pattern={`[0-9]`}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>

          <Form.Item initialValue={type}>
            <Select
              placeholder="Product Type"
              onChange={(val) => setType(val)}
              value={type}
            >
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Option value={type} key={i}>
                  {type?.replace("_", " ")}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item initialValue={null}>
            <Select
              placeholder="Status"
              onChange={(val) => setStatus(val)}
              value={status}
            >
              <Option value={""}>ALL</Option>
              <Option value={"true"}>ACTIVE</Option>
              <Option value={"false"}>INACTIVE</Option>
            </Select>
          </Form.Item>
        </Form>

        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>

      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Promo Code</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Starting Date</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Ending Date</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {promoData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {promoData?.data?.promos?.length ? (
                    promoData?.data?.promos?.map((promo, index) => (
                      <React.Fragment key={index}>
                        <div
                          className="single-product-wrapper"
                          onClick={() => setSelectedId(promo?.id)}
                        >
                          <div className="single-product">
                            <span className="name">{promo?.promoCode}</span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              {moment(promo?.startFrom).format("lll")}
                            </span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              {moment(promo?.endAt).format("lll")}
                            </span>
                          </div>
                          <div className="single-product">
                            <span className="name">
                              {promo?.type?.replace("_", " ")}
                            </span>
                          </div>
                          <div className="single-product">
                            <Switch
                              checkedChildren={<CheckOutlined />}
                              unCheckedChildren={<CloseOutlined />}
                              defaultChecked={promo?.isActive}
                              onChange={(val, e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onStatusChange(promo?.id, val);
                              }}
                              loading={loading}
                              title="Active/Inactive"
                            />
                          </div>

                          <div className="single-product">
                            <button
                              className="btn btn-sm btn-warning mx-1"
                              onClick={() => setSelectedPromoForEdit(promo?.id)}
                            >
                              <EditOutlined />
                            </button>
                          </div>
                        </div>
                      </React.Fragment>
                    ))
                  ) : (
                    <Empty data="Promo Code" />
                  )}
                </div>
              </div>
            )}
          </div>

          <PaginationTwo
            {...promoData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
        <Drawer
          title={
            selectedPromoForEdit ? "Edit Promo Code" : "Promo Code Details"
          }
          width={selectedPromoForEdit ? 600 : 500}
          onClose={onClose}
          visible={selectedPromo || selectedPromoForEdit || selectedId}
          footer={false}
        >
          {selectedPromoForEdit ? (
            <AddPromo
              visibleData={selectedPromoForEdit}
              onCloseMethod={onClose}
            />
          ) : (
            <PromoCodeDetails promoId={selectedId} />
          )}
        </Drawer>
      </div>
    </React.Fragment>
  );
};

export default PromoCodeList;
